import { Conversation } from 'src/graphql';
import { getRequesterDisplayName } from 'src/graphql/entities/conversation/conversation.mappings.utils';
import { formatDisplayDate } from 'src/utils/date';
import { MergeTargetSuggestion, SuggestionBucket } from './suggestions.types';

export const toMergeTargetSuggestion = (
  conversation: Conversation,
  bucket: SuggestionBucket,
): MergeTargetSuggestion => ({
  conversation,
  bucket,
  friendlyId: conversation.friendlyId,
  subject: conversation.subject,
  date: formatDisplayDate(conversation.createdAt),
  requesterName: getRequesterDisplayName(conversation.requesterFullName),
  statusId: conversation.conversationStatusId,
});
